import {Select} from 'antd';
import {useMemo, useState} from 'react';

import {Locale} from '../../../../../provider/locale/locale';
import {useUserTags} from '../../../../../service/reivew-analysis/review-topics/review-topics-hook';
import {debounce} from '../../../../../util/function';
import {useReviewsAnalysisFilter} from '../../reviews-analysis-hook';
import {ReviewsAnalysisFilterEnum} from '../../reviews-analysis-type';
import {renderSelectOption} from '../drawer-filter/drawer-filter-helper';
import {SelectOptionType} from '../drawer-filter/drawer-filter-type';

type PropsType = {
    value?: Array<string>;
    onChange?: (value: Array<string>) => void;
};

export function UserTagsSelect(props: PropsType): JSX.Element {
    const {value, onChange} = props;

    const [q, setQ] = useState<string>('');

    const singleFilter = useReviewsAnalysisFilter();

    const {data: tagsResult, isLoading} = useUserTags(q);

    const {data: tagLabels, isLoading: isUserTagsLoading} = useUserTags(
        '',
        singleFilter.filter[ReviewsAnalysisFilterEnum.UserTagsIds]
    );

    const tagsOptions: Array<SelectOptionType<number>> = useMemo((): Array<SelectOptionType<number>> => {
        return (
            tagsResult?.map<SelectOptionType<number>>(
                (tag): SelectOptionType<number> => ({
                    id: tag.id,
                    name: tag.title,
                })
            ) || []
        );
    }, [tagsResult]);

    const tagsLabelsOptions: Array<SelectOptionType<number>> = useMemo((): Array<SelectOptionType<number>> => {
        return (
            tagLabels?.map<SelectOptionType<number>>(
                (tag): SelectOptionType<number> => ({
                    id: tag.id,
                    name: tag.title,
                })
            ) || []
        );
    }, [tagLabels]);

    const uniqueTagsOptions: Array<SelectOptionType<number>> = useMemo(() => {
        const merged = [...tagsOptions, ...tagsLabelsOptions];
        const uniqueMap = new Map<number, SelectOptionType<number>>();

        merged.forEach((item) => {
            if (!uniqueMap.has(item.id)) {
                uniqueMap.set(item.id, item);
            }
        });

        return [...uniqueMap.values()];
    }, [tagsOptions, tagsLabelsOptions]);

    return (
        <Select<Array<string>>
            disabled={false}
            loading={isLoading || isUserTagsLoading}
            mode="multiple"
            // eslint-disable-next-line no-undefined
            notFoundContent={q === '' ? null : undefined}
            onChange={onChange}
            onSearch={debounce<[string]>(setQ, 300)}
            optionFilterProp="children"
            placeholder={<Locale stringKey="REVIEWS_ANALYSIS__FORM__INPUT__TAGS__PLACEHOLDER" />}
            value={value}
        >
            {uniqueTagsOptions.map(renderSelectOption)}
        </Select>
    );
}
